import { render, staticRenderFns } from "./Combinations.vue?vue&type=template&id=73110962&scoped=true&"
import script from "./Combinations.vue?vue&type=script&lang=js&"
export * from "./Combinations.vue?vue&type=script&lang=js&"
import style0 from "./Combinations.vue?vue&type=style&index=0&id=73110962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73110962",
  null
  
)

export default component.exports